import { gql } from "@apollo/client";

const GET_WIX_TEMP_PRODUCT_LIST = gql`
  query getTempWixProductList($input: GetListInput) {
    getTempWixProductList(input: $input) {
      data {
        count
        tempProductList {
          _id
          name
          image
          isShopifySync
          isSynced
          providerIds
          storeProductId
          status
          updatedAt
          createdAt
        }
      }
      error
      status
    }
  }
`;

export default GET_WIX_TEMP_PRODUCT_LIST;
